module.exports = __webpack_public_path__ + "img/6.779ebde5.webp";